import { render, staticRenderFns } from "./porposal-detail.vue?vue&type=template&id=adf702e6&scoped=true&"
import script from "./porposal-detail.vue?vue&type=script&lang=ts&"
export * from "./porposal-detail.vue?vue&type=script&lang=ts&"
import style0 from "./porposal-detail.vue?vue&type=style&index=0&id=adf702e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf702e6",
  null
  
)

export default component.exports